// extracted by mini-css-extract-plugin
module.exports = {"loader-container":"loader-container_pFRsA","loader-spacer":"loader-spacer_6f-A+"};